import httpClient from "@/http-client";

export const get = (options = {}) => {
    return httpClient
        .get("/api/zones", options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const find = (id, options = {}) => {
    return httpClient
        .get(`/api/zones/${id}`, options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (id, data) => {
    return httpClient
        .put(`/api/zones/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = data => {
    return httpClient
        .post("/api/zones", data, {
            projection: true
        })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const shopList = (options = {}) => {
    return httpClient
        .get(`/api/zones/shop-lists`, options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const shopTypeList = data => {
    return httpClient
        .get("/api/zones/shop-type-lists", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const getDrivers = data => {
    return httpClient
        .get("/api/zones/get-drivers", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const assignDriver = data => {
    return httpClient
        .post("/api/zones/assign-drivers", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = id => {
  return httpClient
      .delete(`/api/zones/${id}`)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data));
}

export default {
    get,
    store,
    shopList,
    shopTypeList,
    find,
    update,
    getDrivers,
    assignDriver,
    destroy
};
